import { version } from "../../package.json";

export const environment = {
  production: true,
  version: version,
  urlPregao: "http://127.0.0.1:5000/item-cotacao",
  urlAmf: "http://cotacao.sghost.com.br:8082/CotacaoWeb/messagebroker/amf",
  urlApi: "http://cotacao.sghost.com.br:8082/CotacaoWeb/servlet/",
  host: "http://cotacao.sghost.com.br:8082",
  pathImg: "assets/images/sg/",
  title: "SG Cotação",
};
